import {
  Component,
  EventEmitter,
  Input,
  Output,
  Signal,
  effect,
  inject,
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { User } from "firebase/auth";
import { StateModule } from "projects/shared-state/lib/state.module";
import { StateService } from "projects/shared-state/lib/state.service";
import { AppProfile } from "projects/shared-state/lib/types/types";
import { WorkflowState } from "projects/shared-state/public-api";

@Component({
  standalone: true,
  selector: "postgenie-new-profile",
  templateUrl: "./new-profile.component.html",
  styleUrls: ["./new-profile.component.scss"],
  imports: [StateModule, FormsModule, ReactiveFormsModule],
})
export class NewProfileComponent {
  stateService = inject(StateService);
  router = inject(Router);

  profileForm: FormGroup = new FormGroup({
    jobDescription: new FormControl("", [Validators.required]),
    department: new FormControl("", [Validators.required]),
    additionalInfo: new FormControl(""),
  });
  @Output() profileEvent = new EventEmitter<any>();

  stateSignal$: Signal<{
    workflow: WorkflowState;
  }> = this.stateService.getAppState();

  @Input() user: User;

  constructor() {
    effect(() => {
      const appProfile: AppProfile =
        this.stateSignal$().workflow.profile?.appProfile;
      if (appProfile?.jobDescription === "") {
      } else if (appProfile) {
        this.navigateTo("home");
      }
    });
  }

  navigateTo(route: string): void {
    this.router.navigate([route], {
      queryParamsHandling: "merge",
    });
  }

  skip(): void {
    this.stateService.skipProfile();
    this.navigateTo("home");
  }

  emitProfile(): void {
    this.profileEvent.emit(this.profileForm.value);
  }
}
